module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-09.377363f1.jpg";